import { gql } from "@apollo/client";

export const CONFIRM_PICKUP_APPOINTMENTS = gql`
  mutation ConfirmPickupAppointments($appointmentIds: [Long!]!) {
    confirmPickupAppointments(appointmentIds: $appointmentIds)
  }
`;

export interface ConfirmPickupAppointmentsResponse {
  confirmPickupAppointments: boolean;
}


